module.exports = __webpack_public_path__ + "static/media/MinionPro-Regular.b85b5ca1.woff2";